import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'

import Panel from 'components/Panel'
import useAuth from 'lib/auth'
import { updateDoc } from 'lib/firestore'

export default function NotificationSetting({ account }) {
  const { user } = useAuth()

  const handleChange = (term, value) => {
    updateDoc(`accounts/${account.id}/members/${user.email}`, {
      [`notify.${term}`]: value,
    }).catch(error => console.log(error))
  }

  return (
    <Panel sx={{ p: 3 }}>
      <Typography
        sx={{
          pb: 1,
          mb: 3,
          borderBottom: theme => `1px solid ${theme.palette.divider}`,
        }}
        variant="h3"
      >
        メール通知
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={account.notify.monthly}
            onChange={e => handleChange('monthly', e.target.checked)}
            name="monthly"
            color="primary"
          />
        }
        label="毎月１日に消費期限の近い商品を知らせる"
      />
      <br />
      <FormControlLabel
        control={
          <Checkbox
            checked={account.notify.daily}
            onChange={e => handleChange('daily', e.target.checked)}
            name="daily"
            color="primary"
          />
        }
        label="毎日消費期限が切れた商品を知らせる"
      />
    </Panel>
  )
}
